import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import MuiPagination from '@mui/material/Pagination';
import TextField from '@mui/material/TextField';
import {
 gridPageCountSelector,
 gridPageSelector,
 gridPageSizeSelector,
 gridRowCountSelector,
 useGridApiContext,
 useGridSelector,
} from '@mui/x-data-grid-pro';
import { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';

import { PAGE_SIZE_OPTIONS } from './constants';

const DataGridPagination = () => {
 const { t } = useTranslation();
 const apiRef = useGridApiContext();
 const page = useGridSelector(apiRef, gridPageSelector);
 const pageCount = useGridSelector(apiRef, gridPageCountSelector);
 const pageSize = useGridSelector(apiRef, gridPageSizeSelector);
 const rowCount = useGridSelector(apiRef, gridRowCountSelector);

 const handlePageSizeChange = (event: ChangeEvent<HTMLInputElement>) => {
  apiRef.current.setPageSize(Number(event.target.value));
 };

 const handlePageChange = (_: ChangeEvent<unknown>, value: number) => {
  apiRef.current.setPage(value - 1);
 };

 const from = rowCount === 0 ? 0 : page * pageSize + 1;
 const to = Math.min(rowCount, (page + 1) * pageSize);

 return (
  <Box
   sx={{
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    width: '100%',
    justifyContent: 'flex-end',
    px: '20px',
   }}
  >
   <TextField
    select
    size="small"
    label={t('global.pagination.perPage')}
    value={pageSize}
    onChange={handlePageSizeChange}
    sx={{ width: 100 }}
   >
    {PAGE_SIZE_OPTIONS.map((option) => (
     <MenuItem key={option} value={option}>
      {option}
     </MenuItem>
    ))}
   </TextField>

   <Box sx={{ fontSize: 14 }}>
    {from}–{to}
    {rowCount > 0 ? ` ${t('global.pagination.of')} ${rowCount}` : ''}
   </Box>

   <MuiPagination
    count={pageCount}
    page={page + 1}
    onChange={handlePageChange}
   />
  </Box>
 );
};

export default DataGridPagination;
